import { Timestamp } from 'firebase/firestore'; // Import Timestamp from Firebase Firestore

export const displayDateFromTimestamp = (timestamp) => {//format timestamp for display purposes
    const selectedDateObj = new Date(timestamp)
    const splitDate = selectedDateObj.toUTCString().split(' ')
    return splitDate[0] + " " + splitDate[1] + " " + splitDate[2] + " " + splitDate[3]
}

export const displayTimeFromTimestamp = (timestamp) => {//format timestamp for display purposes
    const selectedDateObj = new Date(timestamp)
    return ('0' + selectedDateObj.getHours()).slice(-2) + ":" + ('0' + selectedDateObj.getMinutes()).slice(-2)
}


export function compileTimestamp(date, time) {
    if (date && time) {
        const timestamp = new Date(`${date}T${time}`);
        return timestamp; // Return the timestamp
        // You can now use `timestamp` as a Date object
    } else {
        console.log('Please select both date and time.');
    }
}

export function formatFirebaseTimestamp(timestamp, offsetInMinutes = 0) {
    const date = toDateOrNull(timestamp);
    if (!date) return '—';

    const adjustedTime = new Date(date.getTime() + offsetInMinutes * 60000);

    const day = adjustedTime.getDate().toString().padStart(2, '0');
    const month = adjustedTime.toLocaleString('default', { month: 'long' });
    const year = adjustedTime.getFullYear();

    const hours = adjustedTime.getHours().toString().padStart(2, '0');
    const minutes = adjustedTime.getMinutes().toString().padStart(2, '0');
    const seconds = adjustedTime.getSeconds().toString().padStart(2, '0');

    const offsetHours = offsetInMinutes / 60;
    const formattedOffset = `UTC${offsetHours >= 0 ? '+' : ''}${offsetHours}`;
    return `${hours}:${minutes}:${seconds} on ${day} ${month} ${year}`;

    // return `${day} ${month} ${year} at ${hours}:${minutes}:${seconds} ${formattedOffset}`;
}

export function formatCreatedAtDate(timestamp) { //user profile createdAt date (FIREBASE TIMESTAMP)
    try {
        if (timestamp && timestamp.seconds) {
            const date = new Timestamp(timestamp.seconds, timestamp.nanoseconds).toDate();
            return (date.toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            }));
        }
    } catch (error) {
        console.error("Error parsing userData:", error);
    }
}

export function displayDateOrTimeFromFirebase(timestamp, toDisplay, offsetInMinutes = 0) { //user profile createdAt date (FIREBASE TIMESTAMP)
    const date = toDateOrNull(timestamp);
    if (!date) return '—';
    const adjustedTime = new Date(date.getTime() + offsetInMinutes * 60000);

    const day = adjustedTime.getDate().toString().padStart(2, '0');
    const month = adjustedTime.toLocaleString('default', { month: 'long' });
    const year = adjustedTime.getFullYear();

    const hours = adjustedTime.getHours().toString().padStart(2, '0');
    const minutes = adjustedTime.getMinutes().toString().padStart(2, '0');
    // const seconds = adjustedTime.getSeconds().toString().padStart(2, '0');

    const offsetHours = offsetInMinutes / 60;
    // const formattedOffset = `UTC${offsetHours >= 0 ? '+' : ''}${offsetHours}`;

    if (toDisplay === 'date') {
        return `${day} ${month} ${year}`;
    } else {
        return `${hours}:${minutes}`;
    }
}


export function formatMillisTimestamp(ms) {
    if (ms == null || isNaN(ms)) return '—';
    const d = new Date(Number(ms));
    const day = d.getDate().toString().padStart(2, '0');
    const month = d.toLocaleString('default', { month: 'long' });
    const year = d.getFullYear();
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    const seconds = d.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds} on ${day} ${month} ${year}`;
}

export function isSameDay(firebaseTimestamp, lookupDate) { //compare two dates and see if they are the same day
    try {
        const date = firebaseTimestamp.toDate(); // convert Firestore Timestamp to JS Date
        const lookupDateObj = new Date(lookupDate); // convert lookupDate to JS Date
        return (
            date.getFullYear() === lookupDateObj.getFullYear() &&
            date.getMonth() === lookupDateObj.getMonth() &&
            date.getDate() === lookupDateObj.getDate()
        );
    } catch (error) {
        return false; // Handle the error gracefully
    }
}

const WEEKDAY_INDEX = {
    sunday: 0, monday: 1, tuesday: 2, wednesday: 3,
    thursday: 4, friday: 5, saturday: 6,
};

// Any timestamp shape toDateOrNull accepts -> epoch ms (0 when missing/invalid), for sorting
export function timestampToMillis(value) {
    return toDateOrNull(value)?.getTime() ?? 0;
}

// Firestore Timestamp, serialised {seconds}/{_seconds}, Date, epoch ms or ISO string -> Date
function toDateOrNull(value) {
    if (value == null || value === '') return null;
    let date;
    if (typeof value.toDate === 'function') {
        date = value.toDate();
    } else if (typeof value === 'object' && !(value instanceof Date)) {
        const seconds = value.seconds ?? value._seconds;
        if (typeof seconds !== 'number') return null;
        date = new Date(seconds * 1000);
    } else {
        date = new Date(value);
    }
    return isNaN(date) ? null : date;
}

// 'Weekly' | 'Monthly' | 'Once off', whatever casing the event was saved with
function repeatKind(eventObj) {
    const repeat = String(eventObj?.repeat || '').toLowerCase();
    if (repeat === 'weekly') return 'Weekly';
    if (repeat === 'monthly') return 'Monthly';
    return 'Once off';
}

// Does the event happen on the calendar day `lookupDate` (a local-midnight Date)?
// Mirrors newro/utils/dateTime.js: branches on `repeat` + `schedule` before
// `timestamp`, because the app writes repeating events with `timestamp: null`
// and older ones carry a stale `timestamp` from when the series was created.
export function eventOccursOn(eventObj, lookupDate) {
    if (!eventObj) return false;
    const { schedule, timestamp, createdAt } = eventObj;
    const repeat = repeatKind(eventObj);

    // A series never shows before it started
    const start = toDateOrNull(timestamp) || toDateOrNull(createdAt);
    if (start && repeat !== 'Once off') {
        start.setHours(0, 0, 0, 0);
        if (start > lookupDate) return false;
    }

    if (repeat === 'Weekly') {
        if (Array.isArray(schedule?.weekdays) && schedule.weekdays.length > 0) {
            return schedule.weekdays.some(
                (name) => WEEKDAY_INDEX[String(name).toLowerCase()] === lookupDate.getDay()
            );
        }
        const legacy = toDateOrNull(timestamp);
        return !!legacy && legacy.getDay() === lookupDate.getDay();
    }

    if (repeat === 'Monthly') {
        if (typeof schedule?.dayOfMonth === 'number') {
            // Clamp so a 31st-of-month event still shows in shorter months
            const lastDay = new Date(lookupDate.getFullYear(), lookupDate.getMonth() + 1, 0).getDate();
            return Math.min(schedule.dayOfMonth, lastDay) === lookupDate.getDate();
        }
        const legacy = toDateOrNull(timestamp);
        return !!legacy && legacy.getDate() === lookupDate.getDate();
    }

    // Once off: new format keeps the date in schedule.timestamp
    const once = toDateOrNull(schedule?.timestamp) || toDateOrNull(timestamp);
    return !!once &&
        once.getFullYear() === lookupDate.getFullYear() &&
        once.getMonth() === lookupDate.getMonth() &&
        once.getDate() === lookupDate.getDate();
}

const WEEKDAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function joinWithAnd(items) {
    if (items.length <= 1) return items.join('');
    return items.slice(0, -1).join(', ') + ' and ' + items[items.length - 1];
}

function ordinal(n) {
    const rem100 = n % 100;
    if (rem100 >= 11 && rem100 <= 13) return n + 'th';
    return n + ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
}

// Weekday indexes (0 = Sunday) a weekly event runs on, Monday first
function eventWeekdays(eventObj) {
    const fromSchedule = (eventObj?.schedule?.weekdays || [])
        .map((name) => WEEKDAY_INDEX[String(name).toLowerCase()])
        .filter((i) => i != null);
    const days = fromSchedule.length > 0
        ? fromSchedule
        : [toDateOrNull(eventObj?.timestamp)?.getDay()].filter((i) => i != null);
    return [...new Set(days)].sort((a, b) => ((a + 6) % 7) - ((b + 6) % 7));
}

// "Every Monday", "Every month on the 5th" or "12 October 2026"; '—' if unknown
export function displayEventDate(eventObj) {
    const repeat = repeatKind(eventObj);

    if (repeat === 'Weekly') {
        const days = eventWeekdays(eventObj);
        if (days.length === 7) return 'Every day';
        return days.length > 0 ? 'Every ' + joinWithAnd(days.map((i) => WEEKDAY_NAMES[i])) : 'Weekly';
    }

    if (repeat === 'Monthly') {
        const dayOfMonth = typeof eventObj?.schedule?.dayOfMonth === 'number'
            ? eventObj.schedule.dayOfMonth
            : toDateOrNull(eventObj?.timestamp)?.getDate();
        return dayOfMonth ? `Every month on the ${ordinal(dayOfMonth)}` : 'Monthly';
    }

    return displayDateOrTimeFromFirebase(eventObj?.schedule?.timestamp || eventObj?.timestamp, 'date');
}

// HH:MM for an event, preferring schedule.time (repeating events have no timestamp)
export function displayEventTime(eventObj) {
    const time = eventObj?.schedule?.time;
    if (time && typeof time.hours === 'number') {
        return ('0' + time.hours).slice(-2) + ':' + ('0' + (time.minutes || 0)).slice(-2);
    }
    return displayDateOrTimeFromFirebase(eventObj?.schedule?.timestamp || eventObj?.timestamp, 'time');
}

// "Every Monday at 18:00" / "12 October 2026 at 18:00"
export function displayEventSchedule(eventObj) {
    const date = displayEventDate(eventObj);
    const time = displayEventTime(eventObj);
    if (time === '—') return date;
    if (date === '—') return time;
    return `${date} at ${time}`;
}

// 'YYYY-MM-DD' for a date input: the once-off date, or a repeating event's next occurrence
export function eventDateInputValue(eventObj) {
    const toInput = (d) =>
        d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);

    if (repeatKind(eventObj) !== 'Once off') {
        const day = new Date();
        day.setHours(0, 0, 0, 0);
        for (let i = 0; i < 62; i++) {
            if (eventOccursOn(eventObj, day)) return toInput(day);
            day.setDate(day.getDate() + 1);
        }
    }
    const date = toDateOrNull(eventObj?.schedule?.timestamp) || toDateOrNull(eventObj?.timestamp);
    return date ? toInput(date) : '';
}

// 'HH:mm' for a time input, or '' when the event has no time
export function eventTimeInputValue(eventObj) {
    const time = displayEventTime(eventObj);
    return time === '—' ? '' : time;
}

export function displayJustWeekDayFromFirebase(timestamp, offsetInMinutes = 0) { //user profile createdAt date (FIREBASE TIMESTAMP)
    const date = toDateOrNull(timestamp);
    if (!date) return '—';
    const adjustedTime = new Date(date.getTime() + offsetInMinutes * 60000);

    const dayOfWeek = adjustedTime.toLocaleString('default', { weekday: 'long' });
    return dayOfWeek;
}


// export function getConvertedDate(timestampIn) {
//     const date = new Date(timestampIn);
//     const localDate = date.toLocaleString(); // Converts to local timezone
//     const formattedDate = date.toLocaleDateString("en-US", {
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//         hour: "2-digit",
//         minute: "2-digit"
//     });
//     return formattedDate
// }

// export function getConvertedTime(timestampIn) {
//     const date = new Date(timestampIn);
//     const formattedDate = date.toLocaleDateString("en-US", {
//         hour: "2-digit",
//         minute: "2-digit"
//     });
//     return formattedDate
// }